import { FC } from "react";
import Link from "next/link";
import S from "./index.module.scss";
import Image from "next/image";
import { ServiceCenterPageCategoriesResource } from "@/api/generated-api";

interface ICategoryItem {
  category: ServiceCenterPageCategoriesResource;
}

const CategoryItem: FC<ICategoryItem> = ({ category }) => {
  return (
    <Link className={S.categoryButton} href={`/service-center/search?category_id=${category.id}`}>
      <Image
        className={S.categoryImage}
        src={category.icon}
        alt={`category ${category.title}`}
        height={120}
        width={120}
      />
      <span className={S.categoryName}>{category.title}</span>
    </Link>
  );
};

export default CategoryItem;
